"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectStockFile = selectStockFile;
exports.deselectStockFile = deselectStockFile;
exports.acquireImage = acquireImage;
exports.searchShutterstock = void 0;

var ActionTypes = _interopRequireWildcard(require("./ActionTypes"));

var _Constants = require("FileManagerCore/Constants");

var _Shutterstock = require("FileManagerCore/api/Shutterstock");

var _Folders = require("FileManagerCore/api/Folders");

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var SharedShutterstockActions = _interopRequireWildcard(require("FileManagerCore/actions/Shutterstock"));

var _Folders2 = require("FileManagerCore/selectors/Folders");

function selectStockFile(selectedFile) {
  return {
    type: ActionTypes.SELECT_STOCK_FILE,
    selectedFile: selectedFile
  };
}

function deselectStockFile(selectedFile) {
  return {
    type: ActionTypes.SELECT_STOCK_FILE,
    selectedFile: selectedFile
  };
}

var searchShutterstock = SharedShutterstockActions.searchShutterstock;
exports.searchShutterstock = searchShutterstock;

function acquireImage(id, filename, folderId) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: ActionTypes.ACQUIRE_IMAGE_ATTEMPTED,
        id: id,
        filename: filename
      });
      var state = getState();
      var folders = (0, _Folders2.getFolders)(state);

      var doAcquire = function doAcquire(folder) {
        var targetFolderId = folder.get('id');
        return (0, _Shutterstock.acquire)({
          id: id,
          filename: filename,
          targetFolderId: targetFolderId
        }).then(function (response) {
          dispatch({
            type: ActionTypes.ACQUIRE_IMAGE_SUCCEEDED,
            data: response
          });
          resolve(response);
        }).catch(reject);
      };

      var targetFolder;

      if (folderId) {
        targetFolder = folders.find(function (folder) {
          return folder.get('id') === folderId;
        });
      } else if (folderId === null) {
        targetFolder = (0, _FoldersAndFiles.getHomeFolder)();
      }

      if (targetFolder) {
        doAcquire(targetFolder);
      } else {
        var defaultFolder = folders.find(function (folder) {
          return folder.get('full_path') === _Constants.ShutterstockFolderPath;
        });

        if (!defaultFolder) {
          (0, _Folders.add)({
            name: _Constants.ShutterstockFolderName,
            parentId: null
          }).then(function (folder) {
            dispatch({
              type: ActionTypes.ADD_FOLDER_SUCCEEDED,
              folder: folder
            });
            doAcquire(folder);
          }).catch(reject);
        } else {
          doAcquire(defaultFolder);
        }
      }
    });
  };
}